import { render, staticRenderFns } from "./imgRightsBox.vue?vue&type=template&id=3b896936&"
import script from "./imgRightsBox.vue?vue&type=script&lang=js&"
export * from "./imgRightsBox.vue?vue&type=script&lang=js&"
import style0 from "./imgRightsBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports